module.exports = __webpack_public_path__ + "static/media/student-snapshort1-photo.141ce174.png";